var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-placeholder"},[_c('div',{staticClass:"h-color--fill",domProps:{"innerHTML":_vm._s(_vm.site.icon)}}),(!_vm.isAtc)?_c('h1',{class:(_vm.large)?'f-cta1':'f-cta3'},[_vm._v("Image"),_c('br'),_vm._v("Coming"),_c('br'),_vm._v("Soon")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }